export const putOverlay = () => {
  const siteHtml = document.querySelector('html');
  const target = document.querySelector('.site-fixed-nav-bg');
  // close
  if (target) {
    target.classList.remove('active');
    setTimeout(() => {
      target.remove();
      siteHtml.classList.remove('overflow-hidden');
    }, 500);
  }
  // open
  else {
    const elem = document.createElement('div');
    elem.classList.add('site-fixed-nav-bg');
    document.querySelector('body').appendChild(elem);
    siteHtml.classList.add('overflow-hidden');
    elem.classList.add('active');
  }
};
